<template>
  <li class="mui-list-item ff-frac" :title="text">
    <span v-if="!isDecorated" class="content__plain">{{text}}</span>
    <component v-else
      v-for="(op, index) in content"
      v-bind:is="insertType(op.insert)"
      v-bind="insertProps(op.insert)"
      class="content__decorated"
      :key="index">{{op.insert}}</component>
  </li>
</template>

<script>
import { Measure } from '@/components/Formats'
export default {
  components: {
    Measure
  },
  props: {
    content: {
      type: Array,
      default: () => []
    },
    scale: {
      type: String,
      default: '1'
    },
    text: {
      type: String,
      required: true
    }
  },
  computed: {
    isDecorated () {
      return this.content.length > 0 && this.$preference('smartQuantities')
    }
  },
  methods: {
    insertType (insert) {
      if (typeof insert === 'string') return 'span'
      return insert.type
    },
    insertProps (insert) {
      let props = {
        scale: this.scale
      }
      if (typeof insert === 'object') Object.assign(props, insert)
      return props
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Recipe/Ingredient.vue